import { Component, type ErrorInfo, type ReactNode } from 'react';

import { StatusPage } from './StatusPage.tsx';

/**
 * Last safety net: if any screen throws while rendering, show the "Something went wrong"
 * page with a reload button instead of a blank white screen.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };

  static getDerivedStateFromError(): { failed: boolean } {
    return { failed: true };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Screen crashed', error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.failed) return <StatusPage kind="server" onRetry={() => window.location.reload()} />;
    return this.props.children;
  }
}
